import User from '@src/_common/store/user'

export default User
